var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 13.3334V6.54171L7.50016 8.70837L6.3335 7.50004L10.5002 3.33337L14.6668 7.50004L13.5002 8.70837L11.3335 6.54171V13.3334H9.66683ZM5.50016 16.6667C5.04183 16.6667 4.64961 16.5037 4.3235 16.1775C3.99738 15.8514 3.83405 15.4589 3.8335 15V12.5H5.50016V15H15.5002V12.5H17.1668V15C17.1668 15.4584 17.0038 15.8509 16.6777 16.1775C16.3516 16.5042 15.9591 16.6673 15.5002 16.6667H5.50016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadWhite);
export default __webpack_public_path__ + "static/media/upload-white.767926022717a7d8848ee7a8127151ca.svg";
export { ForwardRef as ReactComponent };